export const XC_HEADLESS_SEARCH_CONTENT = '@ap/search-content';
export const XC_HEADLESS_SEARCH_ALL_CONTENT = 'mijn-klant.search.all-content';
